import { textFormatEditor, generateColumn, renderNA, importErrorFunction, generateImportColumn, importTextFormatEditor, formatEditor } from './../../../../../utils/commonFunctions';
import type { ColDef } from "ag-grid-community";
import {
  idColumn,
  actionColumn,
  statusColumn,
} from "../../../../../utils/commonColumns";

/**
 * Column definitions for listing page
 * cellRenderer to show data as a string
 * valueGetter for getting data from export functionality of ag-grid
 * filterValueGetter for getting data from filter
 * tooltipValueGetter for getting data from tooltip
 * textFormatEditor for getting data from text editor
 */
// nameColumn,
const columnDefs: ColDef[] = [
  {
    ...generateImportColumn("", `name`),
    pinned: "left",
    filterValueGetter: (props: any) => {
      return (props.data?.[`name`]);
    },
    ...importErrorFunction(),
  },
  {
    ...generateImportColumn("Certifications", `certifications`),

    cellRenderer: (props: any) => {
      return (props.data?.[`certifications`]?.toString());
    },
    filterValueGetter: (props: any) => {
      return (props.data?.[`certifications`]?.toString());
    },
    ...importErrorFunction(),
  },
  {
    ...generateImportColumn("Industries", `industries`),

    cellRenderer: (props: any) => {
      return (props.data?.[`industries`]?.toString());
    },
    filterValueGetter: (props: any) => {
      return (props.data?.[`industries`]?.toString());
    },
    ...importErrorFunction(),
  },
  {
    ...generateImportColumn("Youtube Video URL", `youtube_video_url`),
    filterValueGetter: (props: any) => {
      return (props.data?.[`youtube_video_url`]);
    },
    ...importErrorFunction(),
  },
  {
    ...generateImportColumn("", `description`),
    ...importTextFormatEditor("description"),
    ...importErrorFunction(),

    tooltipValueGetter: (params: any) => {
      if (
        params.data.errors &&
        Object.hasOwn(params.data.errors, params.colDef.field)
      ) {
        return params?.data?.errors[params.colDef.field]?.toString();
      } else {
        return (formatEditor(params?.data?.["description"]));
      }
    },
  },
  {
    ...generateImportColumn("", `knowledge_skills`),
    ...importTextFormatEditor("knowledge_skills"),
    ...importErrorFunction(),
    tooltipValueGetter: (params: any) => {
      if (
        params.data.errors &&
        Object.hasOwn(params.data.errors, params.colDef.field)
      ) {
        return params?.data?.errors[params.colDef.field]?.toString();
      } else {
        return (formatEditor(params?.data?.["knowledge_skills"]));
      }
    },
  },
  {
    ...generateImportColumn("Education Training", `education_training`),
    ...importTextFormatEditor("education_training"),
    ...importErrorFunction(),
    tooltipValueGetter: (params: any) => {
      if (
        params.data.errors &&
        Object.hasOwn(params.data.errors, params.colDef.field)
      ) {
        return params?.data?.errors[params.colDef.field]?.toString();
      } else {
        return (formatEditor(params?.data?.["education_training"]));
      }
    },
  },
  {
    ...generateImportColumn("", `experience`),
    ...importTextFormatEditor("experience"),
    ...importErrorFunction(),
    tooltipValueGetter: (params: any) => {
      if (
        params.data.errors &&
        Object.hasOwn(params.data.errors, params.colDef.field)
      ) {
        return params?.data?.errors[params.colDef.field]?.toString();
      } else {
        return (formatEditor(params?.data?.["experience"]));
      }
    },
  },
  {
    ...generateImportColumn("Credentialing Require Optional", `credentialing_require_optional`),
    ...importTextFormatEditor("credentialing_require_optional"),
    ...importErrorFunction(),
    tooltipValueGetter: (params: any) => {
      if (
        params.data.errors &&
        Object.hasOwn(params.data.errors, params.colDef.field)
      ) {
        return params?.data?.errors[params.colDef.field]?.toString();
      } else {
        return (formatEditor(params?.data?.["credentialing_require_optional"]));
      }
    },
  },
  // {
  //   ...generateImportColumn("", "salary_range"),
  //   ...importTextFormatEditor("salary_range"),
  //   ...importErrorFunction(),
  //   tooltipValueGetter: (params: any) => {
  //     if (
  //       params.data.errors &&
  //       Object.hasOwn(params.data.errors, params.colDef.field)
  //     ) {
  //       return params?.data?.errors[params.colDef.field]?.toString();
  //     } else {
  //       return (formatEditor(params?.data?.["salary_range"]));
  //     }
  //   },
  // },
  {
    ...generateImportColumn("", `career_path_moves_from_this_role`),
    ...importTextFormatEditor("career_path_moves_from_this_role"),
    ...importErrorFunction(),
    tooltipValueGetter: (params: any) => {
      if (
        params.data.errors &&
        Object.hasOwn(params.data.errors, params.colDef.field)
      ) {
        return params?.data?.errors[params.colDef.field]?.toString();
      } else {
        return (
          formatEditor(params?.data?.["career_path_moves_from_this_role"])
        );
      }
    },
  },
  {
    ...generateImportColumn("Career Category", `career_category`),

    cellRenderer: (props: any) => {
      return (props.data?.[`career_category`]?.toString());
    },
    filterValueGetter: (props: any) => {
      return (props.data?.[`career_category`]?.toString());
    },
    ...importErrorFunction(),
  },
  
  {
    ...generateImportColumn("", `salary_start`),
    filterValueGetter: (props: any) => {
      return (props.data?.[`salary_start`]);
    },
    ...importErrorFunction(),
  },
  {
    ...generateImportColumn("", `salary_end`),
    filterValueGetter: (props: any) => {
      return (props.data?.[`salary_end`]);
    },
    ...importErrorFunction(),
  },
  {
    ...generateImportColumn("Default Status", `default`),
    filterValueGetter: (props: any) => {
      return (props.data?.default == '1' ? "Yes" : "No");
    },
    cellRenderer: (props: any) => {
      return (props.data?.default == '1' ? "Yes" : "No");
    },
    ...importErrorFunction(),
  },
  {
    ...generateImportColumn("Critical Status", `critical`),
    filterValueGetter: (props: any) => {
      return (props.data?.critical == '1' ? "Yes" : "No");
    },
    cellRenderer: (props: any) => {
      return (props.data?.critical == '1' ? "Yes" : "No");
    },
    ...importErrorFunction(),
  },
  {
    ...generateImportColumn("Career Group", `career_group`),
    filterValueGetter: (props: any) => {
      return (props.data?.[`career_group`]);
    },
    ...importErrorFunction(),
  },
  {
    ...generateImportColumn("Career Level", `career_level`),
    filterValueGetter: (props: any) => {
      return (props.data?.[`career_level`]);
    },
    ...importErrorFunction(),
  },
];
export default columnDefs;
